import { Field } from '@datx/core';
import { JsonApiModel } from '../../jsonApi/jsonApiModel';

export class SchoolClassJsonModel extends JsonApiModel {
  public static override readonly type = 'school-classes';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public grade!: number;

  @Field()
  public type!: string;

  @Field()
  public track!: string;
}
